module.exports = __webpack_public_path__ + "img/error-img.f389688.png";